class HiddenElement extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="hidden-element">
          Hidden Element
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-hidden-element" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">A11y Enabled hidden element</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<p>Navigate this section using a screen reader</p>
<p className="hidden-el-demo">
  Well, the way they make shows is, they make one show. That show's called a pilot.
  Then they show that show to the people who make shows, and on the strength of
  that one show they decide if they're going to make more shows. Some pilots get
  picked and become television programs. Some dont, become nothing.
  She starred in one of the ones that became nothing.
</p>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.hidden-el-demo {
  @include hide-element();
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <p>Navigate this section using a screen reader</p>
                  <p className="hidden-el-demo">
                    Well, the way they make shows is, they make one show. That show's called a pilot.
                    Then they show that show to the people who make shows, and on the strength of
                    that one show they decide if they're going to make more shows. Some pilots get
                    picked and become television programs. Some dont, become nothing.
                    She starred in one of the ones that became nothing.
                  </p>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
